/**

 =========================================================================================
 Component - Employee Profile Info
 =========================================================================================
 **/

import React from 'react';

import Avatar from "../../../app-ats/common/avatar";
import Skeleton from "ubs-framework/v2/skeleton";
import {getName} from "ubs-framework/v2/common/function";


const UEmployeeInfo = React.memo(({size, employee, cn, nameClass, showName, isSkeleton, showAvatar, onClick}) => {

    return (
        <React.Fragment>
            <div className={`u_employee-info ${cn}`} onClick={onClick}>
                {isSkeleton ?
                    <>
                        {showAvatar && <Skeleton className={`${showName ? 'u_mr-10' : ''}`} rounded width={size} height={size}/>}
                        {showName && <Skeleton width='100px' height="18px"/>}
                    </>
                    :
                    <>
                        {showAvatar && <Avatar user={employee} width={size}/>}
                        {showName && <span className={`u_employee-info__name u_one-line ${nameClass}`}>{getName(employee)}</span>}
                    </>
                }
            </div>

        </React.Fragment>
    );
})

UEmployeeInfo.defaultProps = {
    cn: '',
    nameClass: '',
    size: 30,
    employee: {},
    showName: true,
    isSkeleton: false,
    onClick: () => {},
    showAvatar: true,
    addS3Url: true,
};

export default UEmployeeInfo;